import { Component, Input, ViewChild } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';
import { Select } from 'ionic-angular';
import { TotvsNotificationProvider } from '../../providers/notification/totvs-notification-provider';
import { TranslateService } from '@ngx-translate/core';


const HTML_TEMPLATE = `
<ion-item no-lines>
    <ion-label class="var-label-one-line">{{variable.description}}</ion-label>
    <ion-toggle color="#0c9abe" [(ngModel)]="variableValue.value" (ionChange)="onChangeCallback()"></ion-toggle>
</ion-item>
`;

const CSS_STYLE = `
.toggle {
    margin-right: 12px !important;
}
`;

@Component({
    selector: 'variable-toggle',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableToggleComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    variableValue: VariableValue;

    constructor() {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "0",
            value: false
        }
    }

    ngOnInit() {
        this.setValue(this.variable.defaultValue);
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: VariableValue): void {
        if (variableValue){
            this.variableValue = {
                asBoolean: variableValue.value,
                asString: String(variableValue.value),
                value: variableValue.value
            }
        }
           

    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.callback(this);
    }

}
